export enum StepState {
    TO_DO,
    PENDING,
    DONE,
}
